<template>
  <div id="lang_record" class="
      shadow-xl
      rounded-md
      lg:border-2 lg:border-blue-600 lg:p-5 lg:ml-6
      md:ml-10
      relative
    ">
    <div id="formtitle" class="
        border-2
        w-full
        flex
        justify-center
        items-center
        bg-blue-600
        text-blue-200
      ">
      <div class="text-sm breadcrumbs">
        <ul>
          <li>
            <a>Application</a>
          </li>
          <li>
            <a>Language</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="
        lg:h-auto
        w-full
        flex flex-col
        items-center
        justify-center
        px-8
        py-4
        mx-5
      ">
      <div class="form-control w-full lg:w-72">
        <label for="Languages" class="label lg:ml-20">
          <span class="label-text font-bold leading-relaxed text-2xl">Languages</span></label>

        <select class="select select-bordered w-full max-w-xs" v-model="Language">
          <option v-for="(l, i) in indianLanguages[0]" :key="i">
            {{ l }}
          </option>
        </select>

        <div class="
            flex flex-row
            justify-center
            text-center
            items-center
            space-x-4
          ">
          <div class="form-control">
            <label for="Speak" class="label">
              <span class="label-text font-semibold">Speak</span></label>
            <input v-model="Speak" type="checkbox" id="Speak" class="checkbox" />
          </div>
          <div class="form-control">
            <label for="Read" class="label">
              <span class="label-text font-semibold">Read</span></label>

            <input v-model="Read" type="checkbox" id="Read" class="checkbox" />
          </div>
          <div class="form-control">
            <label for="Write" class="label">
              <span class="label-text font-semibold">Write</span></label>
            <input v-model="Write" type="checkbox" id="Write" class="checkbox" />
          </div>
        </div>
      </div>

      <div class="form-control w-full lg:w-min mt-10">
        <input @click="addLang" type="button" value="Add" class="btn bg-blue-500 hover:bg-blue-600" />
      </div>
    </div>

    <div class="grid px-5 py-4">
      <div class="overflow-y-auto">
        <table class="table w-full">
          <thead>
            <tr>
              <th></th>
              <th>Action</th>
              <th>Languages</th>
              <th>Speak</th>
              <th>Read</th>
              <th>Write</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, i) in languages" :key="i">
              <th scope="row">{{ ++i }}</th>
              <div class="tooltip tooltip-right" data-tip="After editing your details click add and then save.">
                <td>
                  <span class="cursor-pointer" @click="editRow(--i)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </span>
                </td>
              </div>
              <td>{{ entry.Language }}</td>
              <td>{{ entry.Speak }}</td>
              <td>{{ entry.Read }}</td>
              <td>{{ entry.Write }}</td>
            </tr>
          </tbody>
        </table>
        <div id="button" class="
            mt-6
            mb-5
            border-t-2
            p-2
            flex
            items-center
            justify-center
            tooltip
          " data-tip="Before clicking Save, Click Add to Insert Your Details to the Table Above. And then click Save">
          <button @click="LangData" type="submit" class="btn btn-info mb-2 hover:bg-blue-500 lg:w-96">
            <span v-if="status"><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                fill="currentColor">
                <path fill-rule="evenodd"
                  d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd" />
              </svg></span>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
    <div>
      <div v-if="response" class="alert alert-info absolute bottom-2 left-3">
        <div class="flex-1">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="w-6 h-6 mx-2 stroke-current">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"></path>
          </svg>
          <label>Your data has been saved click next to fill more details</label>
        </div>
      </div>
      <div v-if="error" class="alert alert-error absolute bottom-2 left-3">
        <div class="flex-1">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="w-6 h-6 mx-2 stroke-current">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></path>
          </svg>
          <label>Your data is not saved please try again later or call sitra
            customer serive
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Employerrecord",
  data() {
    return {
      status: false,
      Language: "",
      response: false,
      error: false,
      Read: null,
      Write: null,
      Speak: null,
      indianLanguages: [
        {
          0: "Tamil",
          1: "English",
          2: "Hindi",
          3: "Marathi",
          4: "Telugu",
          5: "Bengali",
          6: "Gujarati",
          7: "Urdu",
          8: "Bhojpuri",
          9: "Kannada",
          10: "Malayalam",
          11: "Odia",
          12: "Punjabi",
          13: "Rajasthani",
          14: "Chhattisgarhi",
          15: "Assamese",
          16: "Maithili",
          17: "Magadhi",
          18: "Haryanvi",
          19: "Khortha",
          20: "Marwari",
          21: "Santali",
          22: "Kashmiri",
          23: "Bundeli",
          24: "Malvi",
          25: "Sadan",
          26: "Mewari",
          27: "Awadhi",
          28: "Wagdi",
          29: "Lamani",
          30: "Pahari",
          31: "Bhili",
          32: "Hara",
          33: "Nepali",
          34: "Gondi",
          35: "Bagheli",
          36: "Sambalpuri",
          37: "Dogri",
          38: "Garhwali",
          39: "Nimadi",
          40: "Surjapuri",
          41: "Konkani",
          42: "Kumaoni",
          43: "Kurukh",
          44: "Tulu",
          45: "Manipuri",
          46: "Surgujia",
          47: "Sindhi",
          48: "Bagri",
          49: "Ahirani",
          50: "Banjari",
          51: "Brajbhasha",
          52: "Dhundhari",
          53: "Bodo",
          54: "Ho",
          55: "Gojri",
          56: "Mundari",
          57: "Garo",
          58: "Kangri",
          59: "Khasi",
          60: "Kachchhi",
        },
      ],
    };
  },
  mounted() {
    this.getLangData();
  },
  beforeUnmount() {
    this.deletelang();
  },
  computed: {
    languages() {
      return this.$store.state.Candidate.application.languages;
    },
  },
  methods: {
    addLang() {
      if (
        this.Language != "" &&
        (this.Read != "" || this.Write != "" || this.Speak != "")
      ) {
        // this.$store.dispatch("addLang", {
        //   Reg_id: sessionStorage.getItem("id"),
        //   Language: this.Language,
        //   Read: String(Boolean(this.Read)),
        //   Write: String(Boolean(this.Write)),
        //   Speak: String(Boolean(this.Speak)),
        // });
        this.$store.dispatch("Candidate/addLang", {
          Reg_id: sessionStorage.getItem("id"),
          Language: this.Language,
          Read: String(Boolean(this.Read)),
          Write: String(Boolean(this.Write)),
          Speak: String(Boolean(this.Speak)),
        });
        // console.log(this.languages);

        this.clearForm();
      } else {
        alert("Enter data to add");
      }
    },
    deletelang() {
      // this.$store.commit("deleteLang");
      this.$store.commit("Candidate/deleteLang");
    },
    clearForm() {
      this.Language = "";
      this.Read = "";
      this.Write = "";
      this.Speak = "";
    },
    editRow(i) {
      this.Language = this.languages[i].Language;
      this.Read = this.languages[i].Read;
      this.Write = this.languages[i].Write;
      this.Speak = this.languages[i].Speak;
      this.$store.dispatch("Candidate/removeLang", i);
    },
    LangData() {
      if (this.languages.length == 0) {
        alert(
          "After filling the form click add to insert it to the table and then click save."
        );
      } else {
        const jsonlang = JSON.stringify(this.languages);
        // console.log(jsonlang);
        axios
          .post(
            ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/InsertLanguage`,
            jsonlang
          )
          .then((res) => {
            // console.log(res);
            if (res.status == 200) {
              this.status = true;
            }
          })
          .catch((err) => alert(err));
      }
    },
    async getLangData() {
      const data = await fetch(
        ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/SelectLanguage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Reg_id: sessionStorage.getItem("id") }),
        }
      );
      try {
        const res = await data.json();
        for (let i = 0; i < res.length; i++) {
          this.languages.push(res[i]);
        }
        // console.log(this.languages)
      } catch (error) {
        alert(error);
      }
    },
  },
};
</script>
